import { EventEmitter, Injectable } from '@angular/core';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { LoggerService } from 'projects/dop-core/src/lib/logger/logger.service';
import { AppConfigService } from './core/app-config/app-config.service';
import { InactivityConfiguration } from './shared/models/configuration.model';
import { TranslationService } from 'projects/dop-core/src/public-api';

@Injectable({
    providedIn: 'root'
})
export class InactivityService {
    private inactivityConfiguration: InactivityConfiguration;

    onIdleStart: EventEmitter<any>;
    onIdleEnd: EventEmitter<any>;
    onTimeoutWarning: EventEmitter<any>;
    onTimeOut: EventEmitter<any>;

    idleState = TranslationService.translate('vbeiNotStarted');
    timedOut = false;

    constructor(
        private readonly idle: Idle,
        private readonly appConfigService: AppConfigService,
        private readonly loggerService: LoggerService
    ) {
        this.appConfigService.configuration$.subscribe(config => {
            if (!config.inactivityConfiguration) {
                return;
            }

            this.inactivityConfiguration = config.inactivityConfiguration;

            // Sets an Idle timeout period in seconds
            if (this.inactivityConfiguration.idleTime) {
                idle.setIdle(this.inactivityConfiguration.idleTime);
            }

            // sets a Timeout period in seconds. After Idle+Timeout seconds of inactivity, the user will be considered timed out
            if (this.inactivityConfiguration.timeOutTime) {
                idle.setTimeout(this.inactivityConfiguration.timeOutTime);
            }
        });

        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        this.onIdleStart = idle.onIdleStart;
        this.onIdleEnd = idle.onIdleEnd;
        this.onTimeOut = idle.onTimeout;
        this.onTimeoutWarning = idle.onTimeoutWarning;

        idle.onIdleEnd.subscribe(() => {
            this.setState(TranslationService.translate('vbeiNoLongerIdle'));
            this.reset();
        });

        idle.onTimeout.subscribe(() => {
            this.setState(TranslationService.translate('vbeiTimedOut'));
            this.timedOut = true;
        });

        idle.onIdleStart.subscribe(() => {
            this.setState(`You've gone idle!`);
        });

        idle.onTimeoutWarning.subscribe((countdown: any) => {
            this.setState(`You will time out in ${countdown} seconds!`);
        });

        this.reset();
    }

    setState(state: string): void {
        this.loggerService.log('InactivityService:', this.idleState);
        this.idleState = state;
    }

    reset(): void {
        this.idle.watch();
        this.setState(TranslationService.translate('vbeiStarted'));
        this.timedOut = false;
    }
}
